import React, {useState, useRef} from 'react'
import DefaultImage from "../assets/upload-photo-here.png";
import EditIcon from "../assets/images/upload.png";
import UploadingAnimation from "../assets/images/soko-loader.gif";
import Header from './layouts/Header';

import Footer from './layouts/Footer';


const ImageUpload = () => {
  const [avatarURL, setAvatarURL] = useState(DefaultImage);

  const fileUploadRef = useRef();

  const handleImageUpload = (event) => {
    event.preventDefault();
    fileUploadRef.current.click();
  }

  const uploadImageDisplay = async () => {
    try {
      setAvatarURL(UploadingAnimation);
      const uploadedFile = fileUploadRef.current.files[0];
      const formData = new FormData();

      formData.append("file", uploadedFile);
      
      // const cachedURL = URL.createObjectURL(uploadedFile);
      // setAvatarURL(cachedURL);

      const response = await fetch("https://api.escuelajs.co/api/v1/files/upload", {
        method: "post",
        body: formData
      });

      if (response.status === 201) {
        const data = await response.json();
        setAvatarURL(data?.location);
      }

    } catch(error) {
      console.error(error);
      setAvatarURL(DefaultImage);
    }


  }

  return (
    <>
    <Header/>
<div className="container-fluid">
     <div className="py-3"></div>
    <div className="relative">
     
    <div className="col-md-4 mb-3">
      <img 
        src={avatarURL}
        alt ="Avatar"
        className="rounded-full" />
    </div>

      <form id="form" encType='multipart/form-data'>
        <button
          type='submit'
          onClick={handleImageUpload}
          className='bg-transparent border-0'>
          <img
            src={EditIcon}
            alt="Edit"
            className='object-fit-cover upload-icon'/>
        </button>
        <input 
          type="file"
          id="file"
          ref={fileUploadRef}
          onChange={uploadImageDisplay}
          hidden />
      </form>  
    </div>
    </div>
      <Footer/>
    </>
  )
}

export default ImageUpload